import { combineReducers } from 'redux';
import { Map } from 'immutable';
import {
  FETCH_SITES,
  FETCH_SITES_SUCCESS,
  SELECT_SITE,
  UNSELECT_SITE,
} from '../actions/sites';
import { tryParseNumber, tryParseNumberArray } from 'utils/parse';

const byId = (state = {}, action) => {
  if (action.response) {
    return {
      ...state,
      ...action.response.entities.caseSites,
    };
  }

  return state;
};

const allIds = (state = [], action) => {
  switch (action.type) {
    case FETCH_SITES_SUCCESS:
      return action.response.result;
    case SELECT_SITE:
      return [...state, action.response.result];
    case UNSELECT_SITE:
      return state.filter(id => id.toString() !== action.site.toString());
    default:
      return state;
  }
};

const deletedIds = (state = [], action) => {
  switch (action.type) {
    case UNSELECT_SITE:
      return [...state, action.site];
    case SELECT_SITE:
      return state.filter(id => id.toString() !== action.response.result);
    default:
      return state;
  }
};

const isFetching = (state = false, action) => {
  switch (action.type) {
    case FETCH_SITES:
      return true;
    case FETCH_SITES_SUCCESS:
      return false;
    default:
      return state;
  }
};

const sites = combineReducers({
  byId,
  allIds,
  deletedIds,
  isFetching,
});

export default sites;

export const getIsFetching = state => state.siteCase.sites.isFetching;

export const getCaseSites = state =>
  state.siteCase.sites.allIds.map(id => state.siteCase.sites.byId[id]);

const getCaseSitesById = sites => {
  const byId = sites.reduce((map, item) => map.set(item.id, item), Map());
  return byId.toObject();
};

const serializeCaseSites = sites =>
  sites.map(cs => {
    var contact_id = tryParseNumber(cs.contact_id);
    var ref_tech_id = tryParseNumber(cs.ref_tech_id);
    return {
      ...cs,
      contact_id: contact_id && contact_id != 0 ? contact_id : null,
      ref_tech_id: ref_tech_id && ref_tech_id != 0 ? ref_tech_id : null,
      security_epis: tryParseNumberArray(cs.security_epis, []),
      inventory_to_plan: tryParseNumberArray(cs.inventory_to_plan, []),
    };
  });

const getSerializedCaseSites = (state, filterFunc) => {
  const filtered = getCaseSites(state).filter(filterFunc);
  return serializeCaseSites(filtered);
};

export const getCreatedCaseSites = state => {
  const created = getSerializedCaseSites(state, cs => cs.new);
  return getCaseSitesById(created);
};

export const getUpdatedCaseSites = state => {
  const updated = getSerializedCaseSites(state, cs => !cs.new);
  return getCaseSitesById(updated);
};

export const getDeletedCaseSites = state => {
  const deleted = state.siteCase.sites.deletedIds.map(
    id => state.siteCase.sites.byId[id]
  );
  return deleted.filter(cs => !cs.new).map(cs => cs.id);
};

export const getCaseSiteById = (state, id) => state.siteCase.sites.byId[id];



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases/form/reducers/sites.js